<div class="basin-content-window basin-scroll-container-vertical">
  <div class="basin-mb-5">
    <basin-stepper class="p-steps p-component green" [readonly]="true" [stepItems]="stepsItem"
      [(stepsActiveIndex)]="currentStep"></basin-stepper>
  </div>
<div>
  <ng-container *ngIf="currentStep === 0">
    <app-create-new-study-area></app-create-new-study-area>
  </ng-container>
  <ng-container *ngIf="currentStep === 1">
    <app-review-study-area></app-review-study-area>
  </ng-container>
</div>
</div>